import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const candidateJobService = {
    getAll,
    show,
};

const MODULE = {
    CANDIDATE_JOB: 'candidate-jobs',
};

const API_URL = API.BASE_URL_API + '/v1/fe';

export function getAll (filter) {
    const request = {
        params: {
            uuid: filter?.uuid,
            company_uuid: filter?.companyUuid,
            department_uuid: filter?.departmentUuid,
            office_uuid: filter?.officeUUID,
            is_intern: filter?.isIntern,
            is_fresh_graduate: filter?.isFreshGraduate,
            is_published: filter?.isPublished,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_JOB}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_JOB}/${uuid}`);
}
